"use client";
import Container from "@/components/Container";
import { PrismicRichText } from "@prismicio/react";

import Member from "./components/Member";
import TitleWithDash from "@/components/TitleWithDash";

/**
 * @typedef {import("@prismicio/client").Content.PersonalInjuryAttorneysSlice} PersonalInjuryAttorneysSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<PersonalInjuryAttorneysSlice>} PersonalInjuryAttorneysProps
 * @param {PersonalInjuryAttorneysProps}
 */
const PersonalInjuryAttorneys = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-[#47414F] relative"
    >
      <div className="h-[78px] md:h-[82px] bg-[#EFEFEF] absolute w-[100%] bottom-0 z-0"></div>
      <Container slice={slice}>
        <div className="flex flex-col lg:max-w-[1172px] gap-[12px] md:flex-row max-w-[690px] mx-auto justify-between items-stretch xl:max-w-none">
          <TitleWithDash
            dashColor={"#C5C5C5"}
            title={
              <PrismicRichText
                field={slice.primary.title}
                components={{
                  heading2: ({ children }) => (
                    <h2
                      className={`
                    title-xl  text-[#FFFFFF] title-font  min-w-[250px] max-w-[250px] w-full lg:max-w-[422px]`}
                    >
                      {children}
                    </h2>
                  ),
                  paragraph: ({ children }) => (
                    <p className="     title-xl  text-[#FFFFFF] title-font  min-w-[250px] max-w-[250px] w-full lg:max-w-[422px] 2xl:max-w-none">
                      {children}
                    </p>
                  ),
                }}
              />
            }
          />
          <PrismicRichText
            field={slice.primary.description}
            components={{
              paragraph: ({ children }) => (
                <p
                  className={`
                  text-medium  md:max-w-[335px] text-[#EEB978] lg:max-w-[522px] `}
                >
                  {children}
                </p>
              ),
            }}
          />
        </div>
        <div className="members card-shadow mt-[24px]  sm:grid-cols-2 md:mt-[40px] mx-auto md:grid md:grid-cols-3 lg:max-w-[888px] relative md:max-w-[690px] xl:mt-[50px] ">
          {slice?.primary.member.map((item, index) => {
            return (
              <div key={index}>
                <Member
                  colorImage={item?.colored_image}
                  image={item?.image}
                  name={item?.title}
                  desgination={item?.desgination}
                  link={item?.link}
                />
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default PersonalInjuryAttorneys;
